import React, {useEffect, useCallback} from 'react';
import Button from '../components/Button';
import t from 'babel-plugin-yate/macro';
import {useDispatch} from 'react-redux';
import {addModal, removeModal} from '../store/app';
import {cancelTransaction, getTransaction} from '../store/transaction';
import CancelTransactionModal from './CancelTransactionModal';

export default function CancelTransactionButton({uuid}) {
  const dispatch = useDispatch();
  const cancelTransactionModalId = 'cancel-transaction';

  useEffect(() => {
    return () => {
      dispatch(removeModal(cancelTransactionModalId));
    };
  }, [dispatch]);

  const openCancelTransactionModalHandler = () => {
    dispatch(addModal(cancelTransactionModalId));
  };

  const customerAction = useCallback(async () => {
    await dispatch(getTransaction(uuid));
  }, [dispatch, uuid]);

  const cancelTransactionHandler = useCallback(async () => {
    const res = await dispatch(cancelTransaction(uuid));

    if (!res.error) {
      customerAction();
    }
  }, [dispatch, uuid, customerAction]);

  return (
    <>
      <CancelTransactionModal
        modalId={cancelTransactionModalId}
        cancelHandler={cancelTransactionHandler}
      />
      <Button
        title={t`Cancel transaction`}
        border={true}
        onClick={openCancelTransactionModalHandler}
      />
    </>
  );
}
